import { render } from "./MainLayout.vue?vue&type=template&id=df412a6c&scoped=true"
const script = {}

import "./MainLayout.vue?vue&type=style&index=0&id=df412a6c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df412a6c"]])

export default __exports__